/* svnty-colour.js: THE COLOUR PIPELINE (D4-25, 2026-09-25; 02:28, image 93: the pinned card of SIMILAR PRODUCTS
 * kept the white picture while the page was on Brown; "the selected colour on the product page changes everything else").
 *
 * THE COLOUR LAW
 *   1. One bus: window.SVNTY.colour owns the product page's selected colour; get() answers { colour, variantId, handle }.
 *   2. One setter: set(colour, source) selects Trade's own colour input and Trade does the rest (variant, ?variant=, price).
 *   3. Every consumer subscribes: document 'svnty:colour' { colour, variantId, handle, source }, or get() when it opens.
 *   4. No consumer writes the picker, and none calls set() in answer to the bus (no loops).
 *   5. Idempotent: the same colour publishes nothing, and every consumer tolerates hearing the same colour twice.
 *
 * How it reads: the picker is Trade's variant-selects inside section[id^="MainProduct-"] (a quick-add modal's picker is
 * another product's and is never read); the colour field is the fieldset whose data-svnty-option names a colour (the same
 * reading as svnty-colour-gallery.js and the sticky bar). It publishes after Trade's own change handler (the change
 * bubbles to document after variant-selects resolved the variant), again as a safety net after Trade's variantChange
 * (the same colour then publishes nothing), and once on load with source "load" after every deferred script has had its
 * DOMContentLoaded, so late consumers hear it and anyone can call get() at any time. Loaded from layout/theme.liquid,
 * before every consumer. Classic deferred script, no dependencies, no console. */
(function () {
  'use strict';
  window.SVNTY = window.SVNTY || {};
  if (window.SVNTY.colour) return;

  var last = null;       /* the colour last published: the idempotence */
  var pending = null;    /* the source named by set(), read by the change that set() causes */

  function main() { return document.querySelector('section[id^="MainProduct-"]'); }
  function selects() { var m = main(); return m ? m.querySelector('variant-selects') : null; }

  /* the colour option's wrapper in Trade's picker, and its index among the options (Trade's own option order) */
  function field() {
    var s = selects(); if (!s) return null;
    var all = s.querySelectorAll('select, fieldset');
    for (var i = 0; i < all.length; i += 1) {
      var wrap = all[i].closest('.product-form__input') || all[i];
      var name = (wrap.getAttribute('data-svnty-option') || '').toLowerCase();
      if (name.indexOf('colour') >= 0 || name.indexOf('color') >= 0) return { el: wrap, index: i };
    }
    return null;
  }

  function read() {
    var f = field(); if (!f) return '';
    var checked = f.el.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;
    var select = f.el.querySelector('select');
    return select ? select.value : '';
  }

  function handle() {
    var s = selects();
    var url = (s && s.dataset.url) || location.pathname;
    var m = String(url).match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  function variants() {
    var s = selects(); if (!s) return [];
    try { if (typeof s.getVariantData === 'function') return s.getVariantData() || []; } catch (e) {}
    try { return JSON.parse((s.querySelector('[type="application/json"]') || {}).textContent || '[]'); } catch (e) { return []; }
  }

  /* the variant on screen when it carries this colour (Trade's resolved one, else the form's id), else the colour's first
     available variant, else its first: a colour whose size combination does not exist still names a real variant */
  function variantFor(colour) {
    var f = field(); var list = variants(); var s = selects();
    if (!f || !colour) {
      var input0 = main() && main().querySelector('form[id^="product-form-"] input[name="id"]');
      return input0 ? String(input0.value) : '';
    }
    var of = function (v) { return v && v.options && v.options[f.index] === colour; };
    if (s && of(s.currentVariant)) return String(s.currentVariant.id);
    var input = main().querySelector('form[id^="product-form-"] input[name="id"]');
    var formId = input ? String(input.value) : '';
    var hit = null, firstAvail = null, first = null;
    list.forEach(function (v) {
      if (!of(v)) return;
      if (String(v.id) === formId) hit = v;
      if (!first) first = v;
      if (!firstAvail && v.available) firstAvail = v;
    });
    var v = hit || firstAvail || first;
    return v ? String(v.id) : formId;
  }

  function get() {
    var colour = read();
    return { colour: colour, variantId: variantFor(colour), handle: handle() };
  }

  function publish(source) {
    if (!selects()) return;
    var colour = read();
    var src = pending || source;
    pending = null;
    if (colour === last) return;
    last = colour;
    var detail = { colour: colour, variantId: variantFor(colour), handle: handle(), source: src };
    window.SVNTY.colour.state = detail;
    document.dispatchEvent(new CustomEvent('svnty:colour', { detail: detail }));
  }

  /* THE ONE SETTER: selects Trade's own input and lets Trade's change handler do its work; true when the colour exists */
  /* a name as a control holds it ("pink", " Light blue ") matched to the value exactly as Trade renders it ("Light Blue") */
  function norm(v) { return String(v == null ? '' : v).replace(/\s+/g, ' ').trim().toLowerCase(); }
  function set(colour, source) {
    var f = field(); if (!f || !colour) return false;
    var want = norm(colour);
    if (norm(read()) === want) return true;
    var radios = f.el.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i += 1) {
      if (norm(radios[i].value) === want) {
        pending = source || 'api';
        radios[i].click();                               /* checks it and fires the change Trade listens to */
        if (pending) publish(pending);                   /* a click swallowed by the platform still reaches the bus */
        return true;
      }
    }
    var select = f.el.querySelector('select');
    var opt = select ? Array.prototype.find.call(select.options, function (o) { return norm(o.value) === want; }) : null;
    if (opt) {
      pending = source || 'api';
      select.value = opt.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      if (pending) publish(pending);
      return true;
    }
    return false;
  }

  /* after Trade's own handler (it sits on variant-selects; document hears the bubble after it) */
  document.addEventListener('change', function (e) {
    var s = selects();
    if (!s || !e.target || !s.contains(e.target)) return;
    publish('picker');
  });

  function boot() {
    try {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.variantChange) {
        subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
          var s = selects(); if (!s) return;
          var id = ev && ev.data && ev.data.sectionId;
          if (id && id !== (s.dataset.originalSection || s.dataset.section)) return;   /* another product's picker */
          publish('variant');
        });
      }
    } catch (e) {}
    /* the first word, once every deferred script has run its own DOMContentLoaded (A-08, D5-1): boot() runs DURING the
       deferred scripts (readyState is already "interactive"), so a bare setTimeout could speak before a later deferred
       consumer had registered. Deferred scripts all finish before DOMContentLoaded, so the word waits for it (the window's
       load is the fallback for a boot that came after it, and a boot after "complete" speaks at once). */
    var said = false;
    var first = function () {
      if (said) return; said = true;
      setTimeout(function () {
        if (!selects()) return;
        window.SVNTY.colour.ready = true;
        publish('load');
      }, 0);
    };
    if (document.readyState === 'complete') first();
    else { document.addEventListener('DOMContentLoaded', first); window.addEventListener('load', first); }
  }

  window.SVNTY.colour = { get: get, set: set, ready: false, state: null };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
